import React, { useState } from "react";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    address: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch("https://cryptools-server-production.up.railway.app/api/register", {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          alert("Registration successful, please log in.");
          window.location.href = "/";
        } else {
          alert("Registration failed.");
          throw new Error("Registration failed.");
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <form onSubmit={handleSubmit} className="w-10/12 md:w-1/4 m-auto">
      <label className="flex flex-col">
        Name:
        <input
          type="text"
          name="name"
          className="form-input shadow appearance-none border rounded w-50 my-1 ml-2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={formData.name}
          onChange={handleChange}
        />
      </label>
      <br />
      <label className="flex flex-col">
        Email:
        <input
          type="email"
          name="email"
          className="form-input shadow appearance-none border rounded w-50 my-1 ml-2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={formData.email}
          onChange={handleChange}
        />
      </label>
      <br />
      <label className="flex flex-col">
        Password:
        <input
          type="password"
          name="password"
          className="form-input shadow appearance-none border rounded w-50 my-1 ml-2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={formData.password}
          onChange={handleChange}
        />
      </label>
      <br />
      <label className="flex flex-col">
        Address:
        <input
          type="text"
          name="address"
          className="form-input shadow appearance-none border rounded w-50 my-1 ml-2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={formData.address}
          onChange={handleChange}
        />
      </label>
      <br />
      <button type="submit" className="flex m-auto py-2 px-5 rounded-lg font-medium text-white text-center bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700 duration-150 md:py-3 md:inline md:mr-4 md:mb-0">Register</button>
    </form>
  );
};

export default Register;
